import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {SmartFilterBase} from '@shared/components/smart-filters/smart-filter-base.component';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable, Subject} from 'rxjs';
import {take, takeUntil, map} from 'rxjs/operators';
import {QueryProvider} from '@shared/queries/query-provider';
import {select, Store} from '@ngrx/store';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {SchedulerEvent} from '@progress/kendo-angular-scheduler';
import {TimeZoneService} from '@core/services/time-zone.service';
import {Configuration} from '@shared/models/configuration';
import {DateCellViewerComponent} from '../cell-components/date-cell-viewer/date-cell-viewer.component';
import {ManageCellViewerComponent} from '../cell-components/manage-cell-viewer/manage-cell-viewer.component';
import {EventCellViewerComponent} from '../cell-components/event-cell-viewer/event-cell-viewer.component';
import {ParticleService} from '@core/services/particle.service';
import {InvalidateSmartGridAction} from '@shared/store/actions/smart-grid.actions';
import {ISmartGridDataCollectionState} from '@shared/store/reducers/smart-grid.reducers';
import {SmartGridService} from '@core/services/smart-grid.service';


@Component({
    standalone: false,
    selector: 'particle-due-dates-widget',
  templateUrl: './due-dates-widget.component.html',
  styleUrls: ['./due-dates-widget.component.scss']
})
export class DueDatesWidgetComponent extends SmartFilterBase implements OnInit, OnDestroy {
  dueDates$: Observable<any>;
  hasData$: Observable<boolean>;
  dataLoaded: boolean = false;
  dataInited: boolean = false;
  dueDates: any;
  unsubscribe$ = new Subject<void>();
  dueDateString: string;
  dueDateEvents: SchedulerEvent[] = [];
  sourceKey: string;
  queryKey: string;
  fromDate: Date;
  toDate: Date;
  gridInitialized: boolean = false;
  newsDateString: string;

  constructor(public changeDetectorRef: ChangeDetectorRef,
              private queryStore: Store<IQueryState>,
              private activatedRoute: ActivatedRoute,
              private timeZoneService: TimeZoneService,
              private router: Router,
              private particleService: ParticleService,
              private smartGridStore: Store<ISmartGridDataCollectionState>,
              private smartGridService: SmartGridService) {
    super(changeDetectorRef);
    this.sourceKey = 'Due-Date-Scheduler';
    particleService.registerCellComponent('SchedulerDateCellViewer', DateCellViewerComponent);
    particleService.registerCellComponent('SchedulerEventCellViewer', EventCellViewerComponent);
    particleService.registerCellComponent('SchedulerManageCellViewer', ManageCellViewerComponent);
  }

  ngOnInit() {
    this.dataLoaded = false;
    this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscribe$)).subscribe(queryParams => {
      this.queryParameters = {...queryParams};
      if (queryParams.newsDate) {
        this.newsDateString = queryParams.newsDate;
      }
      if (this.queryParameters.groupId) {
        delete this.queryParameters.groupId;
        this.router.navigate([], {relativeTo: this.activatedRoute, queryParams: this.queryParameters});
      }
    });

    this.sourceKey = this.currentFilter.arguments['SourceKey'];
    this.queryKey = this.currentFilter.arguments['QueryKey'];
    QueryProvider.invokeQuery(this.queryStore, this.queryKey, {
      '[EXECUTION_ID]': this.filter.id
    });
    this.dueDates$ = this.queryStore.pipe(select(getQueryResponse, this.queryKey));
    this.dueDates$.pipe(takeUntil(this.unsubscribe$)).subscribe(dueDateResponse => {
      let hasData = false;
      if (dueDateResponse) {
        this.dataLoaded = true;
        this.dueDates = dueDateResponse;
        hasData = this.dueDates && dueDateResponse.recordCount > 0;
      }
      this.currentFilter.title = hasData ? `Due Dates (${dueDateResponse.recordCount})` : 'Due Dates';
    });
    this.hasData$ = this.dueDates$.pipe(map(duedates => {
      const hasData = duedates && duedates.recordCount > 0;
      return hasData;
    }));

    const config = Configuration.getSmartGridConfig(this.sourceKey);
    config.Parameters['EXECUTION_ID'] = this.filter.id;

    Configuration.setSmartGridConfig(this.sourceKey, config);
    this.fromDate = new Date();
    this.toDate = new Date();
    this.fromDate.setDate(this.fromDate.getDate() + 1);
    this.toDate.setDate(this.fromDate.getDate() + 60);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
